import {
  Avatar,
  Flex,
  Text,
  Title,
  useComputedColorScheme,
  useMantineColorScheme,
  Menu,
  // ActionIcon,
  // Tooltip,
  // useMantineTheme,
  // Badge,
} from '@mantine/core';
// import { IconMessageFilled } from '@tabler/icons-react';
import React from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { ColorSchemeToggle } from './ColorSchemeToggle';
// import { Chat } from 'components/layout/components/Chat';
import { useNavigate } from 'react-router-dom';
import { useLogout } from 'hooks';
import { useCheatSheet } from 'constants/CheatSheetContext';
import { useTranslation } from '@refinedev/core';

interface UserSectionProps {
  isAdmin: boolean;
  isProvider: boolean;
}

export const UserSection: React.FC<UserSectionProps> = ({
  isAdmin,
  isProvider,
}) => {
  // const [chatOpened, setChatOpened] = useState<boolean>(false);
  // const [clicked, setClicked] = useState<boolean>(false);
  const { firstName, lastName, role } = useCurrentUserStore();
  const { toggleColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('dark');
  // const theme = useMantineTheme();
  const navigate = useNavigate();
  const logout = useLogout();
  const { toggle: toggleCheatSheet } = useCheatSheet();
  const { translate } = useTranslation();

  const determineUserRole = () => {
    if (isAdmin) {
      return 'Administrator';
    } else if (isProvider) {
      return 'Provider';
    } else {
      const roleName = role?.name || 'Billing User';
      return roleName;
    }
  };

  return (
    <>
      {/* <Chat opened={chatOpened} setOpened={setChatOpened} /> */}
      <Flex direction="column" justify="flex-end" align="center">
        <Title
          order={2}
          data-testid="header-user-name"
          fz={'14px'}
          ta={'center'}
          lh={'xs'}
        >
          {firstName} {lastName}
        </Title>
        <Text c="dimmed" size="xs">
          {determineUserRole()}
        </Text>
      </Flex>
      {/* {cognitoGroupRole === 'PROVIDER' ? (
        <Tooltip label="Chat with one of our knowlegable billing clerks">
          <ActionIcon
            size="xl"
            variant="transparent"
            onClick={() => setChatOpened(!chatOpened)}
          >
            <IconMessageFilled
              style={{ color: theme.colors[`gray-${computedColorScheme}`][0] }}
            />
          </ActionIcon>
        </Tooltip>
      ) : (
        <ActionIcon
          size="xl"
          variant="transparent"
          onClick={() => {
            setClicked(true);
            setChatOpened(!chatOpened);
          }}
          style={{
            position: 'relative', // establish a positioning context
            overflow: 'visible', // allow children to render outside
          }}
        >
          <IconMessageFilled
            style={{ color: theme.colors[`gray-${computedColorScheme}`][0] }}
          />
          <Badge
            size="xs"
            circle
            color="red"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              transform: 'translate(25%, -25%)',
              visibility: clicked ? 'hidden' : undefined,
            }}
          >
            1
          </Badge>
        </ActionIcon>
      )} */}

      <Flex justify={'flex-end'} align={'center'}>
        <Menu position="bottom" withArrow>
          <Menu.Target>
            <Avatar
              radius="xl"
              style={{ cursor: 'pointer' }}
              className="user-avatar-dropdown"
            >
              {firstName?.[0]}
              {lastName?.[0]}
            </Avatar>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item
              onClick={() => {
                navigate('/settings');
              }}
            >
              {translate('pages:settings.label')}
            </Menu.Item>
            <Menu.Item onClick={() => toggleCheatSheet()}>
              {translate('buttons.viewKeyboardShortcuts')}
            </Menu.Item>
            <Menu.Item color="red" onClick={logout}>
              {translate('buttons.logout')}
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
        <ColorSchemeToggle
          colorScheme={computedColorScheme}
          toggleColorScheme={toggleColorScheme}
        />
      </Flex>
    </>
  );
};
